import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/index';
import About from './pages/about-us';
import Attractions from './pages/attractions';
import ContactUs from './pages/contact-us';
import CorporateSchool from './pages/corporate-school';
import Events from './pages/events';
import Media from './pages/media';
import NearbyPlaces from './pages/nearby-places';
import Offers from './pages/offers';
import TicketsOffers from './pages/tickets-offers';
import LatestHappenings from './pages/latest-happenings';
import AttractionDetails from './pages/attractions-details';
import OfferDetails from './pages/offer-details';
import PageNotFound from './pages/404';
import PoliciesDetails from './pages/policies';
import ThingsToDoDetail from './pages/things-to-do';
import StatueHelpDetail from './pages/help';
import ParkStayDetail from './pages/park-stay';
import NathdwaraAttractionDetails from './pages/nathdwara-attractions';
import EventsDetails from './pages/events-details';
import TermsConditions from './pages/tandc';
import Faqs from './pages/faqs';
import FaqPage from './pages/faqs';
import HowToReach from './pages/how-to-reach';
import VideoGallery from './pages/video-gallery';
import OurIntiatives from './pages/our-initiatives';
import AnnualReturn from './pages/annual-return';
import ExtractOfAnnualReturn from './pages/extract-of-annual-return';
import NoticeOfCandidature from './pages/notice-of-candidature-of-a-person-for-directorship';
import NoticeOfGeneralMeeting from './pages/notice-of-general-meeting';
import NoticeOfResignation from './pages/notice-of-resignation-of-directors';
import PublicationOfNameByCompany from './pages/publication-of-name-by-company';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
      <Routes>
          <Route path="/tandc.html" element={<TermsConditions />} />
        </Routes>
      <Routes>
        <Route path="/about-us" element={<About />} />
      </Routes>
        <Routes>
          <Route path="/attractions" element={<Attractions />} />
        </Routes>
        <Routes>
          <Route path="/contact-us" element={<ContactUs />} />
        </Routes>
        <Routes>
          <Route path="/contact-us" element={<CorporateSchool />} />
        </Routes>
        <Routes>
          <Route path="/events" element={<Events />} />
        </Routes>
        <Routes>
          <Route path="/events/:id/:slug" element={<EventsDetails />} />
        </Routes>
        <Routes>
          <Route path="/media" element={<Media />} />
        </Routes>
        <Routes>
          <Route path="/places-to-visit-near-nathdwara" element={<NearbyPlaces />} />
        </Routes>
        <Routes>
          <Route path="/places-to-visit-near-nathdwara/:id/:title" element={<NathdwaraAttractionDetails />} />
        </Routes>
        <Routes>
          <Route path="/offers" element={<Offers />} />
        </Routes>
        <Routes>
          <Route path="/tickets-offers" element={<TicketsOffers />} />
        </Routes>
        <Routes>
          <Route path="/latest-happenings/:id/:title" element={<LatestHappenings />} />
        </Routes>
        <Routes>
          <Route path="/our-attractions/:id/:title" element={<AttractionDetails />} />
        </Routes>
        <Routes>
          <Route path="/offers/:id/:title" element={<OfferDetails />} />
        </Routes>
        <Routes>
        <Route path="/policies/:id/:slug" element={<PoliciesDetails />} />
        </Routes>
        <Routes>
          <Route path="/things-to-do/:id/:slug" element={<ThingsToDoDetail />} />
        </Routes>
        <Routes>
          <Route path="/park-and-stay/:id/:slug" element={<ParkStayDetail />} />
        </Routes>
        <Routes>
          <Route path="/help/:id/:slug" element={<StatueHelpDetail />} />
        </Routes>
        <Routes>
          <Route path="/faqs" element={<FaqPage />} />
        </Routes>
        <Routes>
          <Route path="/how-to-reach-statue-of-belief" element={<HowToReach />} />
        </Routes>
        <Routes>
          <Route path="/video-gallery" element={<VideoGallery />} />
        </Routes>
        <Routes>
          <Route path="/our-initiatives" element={<OurIntiatives />} />
        </Routes>
        <Routes>
          <Route path="/annual-return" element={<AnnualReturn />} />
        </Routes>
        <Routes>
          <Route path="/extract-of-annual-return" element={<ExtractOfAnnualReturn />} />
        </Routes>
        <Routes>
          <Route path="/notice-of-candidature-of-a-person-for-directorship" element={<NoticeOfCandidature />} />
        </Routes>
        <Routes>
          <Route path="/notice-of-general-meeting" element={<NoticeOfGeneralMeeting />} />
        </Routes>
        <Routes>
          <Route path="/notice-of-resignation-of-directors" element={<NoticeOfResignation />} />
        </Routes>
        <Routes>
          <Route path="/publication-of-name-by-company" element={<PublicationOfNameByCompany />} />
        </Routes>
        <Routes>
          <Route path="*" element={<PageNotFound />} />
        </Routes>
    </BrowserRouter>
  );
}

export default App;
